
class Pageable {
    page: number;
    size: number;
    sort: string;
    first: number;

    constructor(page: number, size: number, sort: string, first: number) {
        this.page = page;
        this.size = size;
        this.sort = sort;
        this.first = first;
    }
}

export default Pageable;
